<template>
  <b-modal
    :id="id"
    :title="'QR code' | i18n"
    button-size="sm"
    centered
    hide-footer
    content-class="rounded-8"
    @show="showModal"
    @hidden="resetModal"
  >
    <div v-if="token" class="qr-box">
      <QRCanvas :options="options" />
    </div>
    <div v-else>
      <Loader />
    </div>
  </b-modal>
</template>

<script>
import axios from 'axios';
import { QRCanvas } from 'qrcanvas-vue';
import api from '../../api/index';
import Loader from '../../components/common/loader';

export default {
  name: 'QRCode',
  components: {
    QRCanvas,
    Loader,
  },
  props: {
    id: {
      type: String,
      default: '',
    },
    userId: {
      type: String,
      default: '',
    },
    qrCodeId: {
      type: String,
      default: '',
    },
    isPersonal: {
      type: Boolean,
      default: false,
    },
    scope: {
      type: Object,
      default: () => {},
    },
    expiresIn: {
      type: [Number, String],
      default: 86400,
    },
  },
  data: function () {
    return {
      options: {
        cellSize: 6,
        data: '',
      },
      token: false,
    };
  },
  methods: {
    async showModal() {
      this.token = false;

      const data = {
        expiresIn: this.expiresIn,
        scope: this.scope,
      };

      if (this.userId) {
        data.id = this.userId;
      }
      if (this.qrCodeId) {
        data.qrCode = this.qrCodeId;
      }
      const { token } = await api.auth.generateQRCode(data);

      this.token = token;

      const info = {
        url: axios.defaults.baseURL,
        token: token,
      };

      if (this.qrCodeId && !this.isPersonal) {
        info.qrCodeId = this.qrCodeId;
      }

      this.options.data = JSON.stringify(info);
    },
    async resetModal() {},
    async submit() {},
  },
};
</script>

<style scoped>
.qr-box {
  display: flex;
  justify-content: center;
  width: 100%;
  align-content: center;
  align-items: center;
}
::v-deep .modal-header {
  border: none;
  padding-bottom: 0px!important;
}
::v-deep .rounded-8 {
  border-radius: 8px;
}
</style>
